// Generated by ts-to-zod
import { z } from 'zod';

export const queueDeleteQuerySchema = z.object({
  deleteAfter: z.string().optional(),
});
